import ajax from "./ajax";

export function checkoutOrder(params) {
  return ajax("/orders", { method: "POST", data: params });
}

export function placeOrder(params) {
  return ajax("OrderCheckout/checkout", { method: "POST", data: params });
}

export function createPayment(params) {
  return ajax("/OrderCheckout/pay-now", { method: "POST", data: params });
}

export function verifyPayment(params) {
  return ajax("/OrderCheckout/verify-payment", {
    method: "POST",
    data: params,
  });
}

export function getAllOrders() {
  return ajax("/orders?sort=-id&per-page=1000");
}

export function getOrderDetails(orderId) {
  return ajax(`/orders/items?orderId=${orderId}`);
}

export function getPaymentGateways() {
  return ajax(`/PaymentGateway?sort=display_order`);
}

export function getPlans() {
  return ajax(`/Plan/index?sort=display_order`);
}
export function getBillHistory(userId, page = 1, pageSize = 10) {
  return ajax(
    `/Dashboard/payment-history/user/${userId}?page=${page}&pageSize=${pageSize}`,
  );
}

export function getInvoice(userId) {
  return ajax(`/Invoice/download/${userId}`, {
    responseType: "blob",
  });
};



export function getCreditsHistory(page = 1, pageSize = 10) {
  return ajax(
    `/PurchasedCandidates/GetPurchasedCandidates?page=${page}&pageSize=${pageSize}`,
  );
}
export function getDashboard(page = 1, pageSize = 10) {
  return ajax(
    `/Dashboard?page=${page}&pageSize=${pageSize}`,
  );
}

export function getPlanHistory(page = 1, pageSize = 10) {
  return ajax(
    `CreditHistory/my?page=${page}&pageSize=${pageSize}`,
  );
}
